exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".index__iframe___1fQZr{border:none;width:100%;height:800px}", "", {"version":3,"sources":["/./src/routes/SocialMediaRewardList/src/routes/SocialMediaRewardList/containers/index.scss"],"names":[],"mappings":"AACA,uBACE,YAAY,WACD,YACE,CACd","file":"index.scss","sourcesContent":["\n.iframe {\n  border: none;\n  width: 100%;\n  height: 800px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"iframe": "index__iframe___1fQZr"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader?sourceMap!./src/routes/SocialMediaRewardList/containers/index.scss
// module id = 2678
// module chunks = 0